import React from 'react';

import Logo from '~components/PrerenderLogo';
import { isSafariBrowser } from '~library/browser';
import { EXPORT_VIEWPORT_PX } from '~library/print';

type PrintableLayoutProps = {
  children: React.ReactNode;
};

const SAFARI_CLASS_NAME = 'browser-safari';

/** Screen + print wrapper for PDF export routes: grey shell and fixed A4-ish viewport. */
export function PrintableExportShell({ children }: React.PropsWithChildren) {
  React.useEffect(() => {
    if (isSafariBrowser()) {
      document.documentElement.classList.add(SAFARI_CLASS_NAME);
    }

    return () => {
      document.documentElement.classList.remove(SAFARI_CLASS_NAME);
    };
  }, []);

  return (
    <div className="export-print-screen-shell">
      <div
        className="dashboard-export-viewport"
        style={{
          width: EXPORT_VIEWPORT_PX.width,
          height: EXPORT_VIEWPORT_PX.height,
          margin: '0 auto',
          overflow: 'auto',
          boxSizing: 'border-box',
        }}
      >
        {children}
      </div>
    </div>
  );
}

export function PrintablePageFooter() {
  return (
    <div className="printable-page__footer">
      <Logo />
    </div>
  );
}

export function Page({ children }: PrintableLayoutProps) {
  return (
    <div className="printable-page">
      {children}

      <PrintablePageFooter />
    </div>
  );
}

export function PageContent({ children }: PrintableLayoutProps) {
  return <div>{children}</div>;
}


